import axios from 'axios';
const API_HOST = process.env.API_HOST;
const API_WORKFLOW = process.env.API_WORKFLOW;
const API_COMM = process.env.API_COMM;

export const api = axios.create({
    baseURL: `https://${API_HOST}`,
    headers: {
        'Content-Type': 'application/json',
    },
});

export const apiN8N = axios.create({
    baseURL: `${API_WORKFLOW}`,
    headers: {
        'Content-Type': 'application/json',
    },
});

export const apiComm = axios.create({
    baseURL: `${API_COMM}`,
    headers: {
        'Content-Type': 'application/json',
    },
});